import React, { useState } from 'react';
import { CardContent, Card, Typography, Grid, CardActions, Button, Popover, CircularProgress } from '@material-ui/core';
import { usePopupState, bindPopover, bindTrigger } from 'material-ui-popup-state/hooks';

import calendarIcon from '../../assets/calendar.png';
import goldenDemandMedal from '../../assets/golden-demand.png';
import clockIcon from '../../assets/clock.png';
import locationIcon from '../../assets/location.png';
import zipCodeIcon from '../../assets/zip-code.png';

const GoldenDemandCard = ({ id, category, subcategory, description, zipCode, timeAgo, location, isFullTime,
    isActive, isExclusive, onDeactivateClick }) => {
    const [isRequesting, setIsRequesting] = useState(false);
    const popupState = usePopupState({ variant: 'popover' });

    return (
        <Card style={{ backgroundColor: isActive ? '#fff' : '#d9d9d9' }} elevation={isActive ? 3 : 1}>
            <CardContent>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <Typography variant="h6">{category}</Typography>
                        <Typography variant="subtitle1" style={{ color: '#727272' }}>{subcategory}</Typography>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <img src={goldenDemandMedal} alt="Golden Demand medal" style={{ maxWidth: '40%' }} />
                    </div>
                </div>
                <Typography variant="h6">Description:</Typography>
                <Typography variant="body1" noWrap={true}>{description}</Typography>

                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <InlineImageIcon icon={zipCodeIcon}>{zipCode}</InlineImageIcon>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InlineImageIcon icon={locationIcon}>{location}</InlineImageIcon>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InlineImageIcon icon={calendarIcon}>{timeAgo} ago</InlineImageIcon>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InlineImageIcon icon={clockIcon}>{isFullTime ? 'Full Time' : 'Part Time'}</InlineImageIcon>
                    </Grid>
                </Grid>
            </CardContent>
            <CardActions style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                <Typography variant="body1">{isExclusive ? 'InstaJob\'s Exclusive' : ''}</Typography>
                <Button variant="outlined" color="secondary" {...bindTrigger(popupState)}>{isActive ? 'Deactivate' : 'Activate'}</Button>
                <Popover
                    {...bindPopover(popupState)}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    PaperProps={{ style: { padding: 15 } }}
                >
                    <Typography variant="body1">
                        Do you want to {!isActive ? 'activate' : 'deactivate'} this demand?
                        <br />
                        {isActive ? 'This will hide your demand in our App\'s Job Panel.' : 'This will show this demand in our App\'s Job Panel.'}
                    </Typography>
                    <div style={{ textAlign: 'right', width: '100%' }}>
                        <Button onClick={() => popupState.setOpen(false)} style={{ marginRight: 15 }}>No, go back</Button>
                        <Button variant="contained" color="primary" disabled={isRequesting} onClick={() => {
                            setIsRequesting(true);
                            onDeactivateClick(id, !isActive).then(() => {
                                setIsRequesting(false);
                                popupState.setOpen(false);
                            });
                        }}>
                            Yes, {!isActive ? 'activate' : 'deactivate'} it {isRequesting && <CircularProgress />}
                        </Button>
                    </div>
                </Popover>
            </CardActions>
        </Card>
    )
}


const InlineImageIcon = ({ icon, children }) => {
    return (
        <div style={{ display: 'inline-flex', flexDirection: 'row', alignItems: 'center' }}>
            <img src={icon} style={{ marginRight: 15, width: 20 }} />
            {children}
        </div>
    )
};

export default GoldenDemandCard;